import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReviewStatus } from 'src/app/common/constants';
import { Global } from 'src/app/_services/global.service';
import { ModalService } from 'src/app/_services/modal.service';
import { PartnerService } from 'src/app/_services/partner.service';
import { UpdateVersionComponent } from './update-version/update-version.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { InfiniteGridComponent } from 'src/app/ui-library/component/infinite-grid/infinite-grid.component';

@Component({
  selector: 'app-product-version',
  templateUrl: './product-version.component.html',
  styleUrls: ['./product-version.component.scss'],
  providers: [DatePipe]
})
export class ProductVersionComponent extends InfiniteGridComponent {
  initialProduct: string

  readonly TabList = ['Product', '3DModel']
  currentFocusOn: string = 'Product'

  constructor(
    private partnerService: PartnerService,
    public global: Global,
    private datePipe: DatePipe,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private nzModalService: NzModalService

  ) {
    super(global);
    this.initialProduct = this.route.snapshot.paramMap.get('productId');
    this.currentFocusOn = this.route.snapshot.paramMap.get('type') || 'Product';

  }


  ngAfterViewInit(): void {
    this.fetchAll()
  }

  ngOnInit() {
    this.setColumnDefs();
  }

  formatDateTime(params) {
    return this.datePipe.transform(params.value, 'short')
  }


  setColumnDefs() {
    this.columnDefs = [
      { headerName: 'Id', field: 'id' },
      { headerName: 'Review Status', field: 'reviewStatus' },
      { headerName: `${this.currentFocusOn === 'Product' ? 'Product Id' : 'Model Id'}`, field: `${this.currentFocusOn === 'Product' ? 'productId' : 'modelId'}` },
      { headerName: `${this.currentFocusOn === 'Product' ? 'Product Name' : 'Model Name'}`, field: `${this.currentFocusOn === 'Product' ? 'product.name' : 'model.name'}` },
      { headerName: 'Status', field: 'status' },
      {
        headerName: 'Action',
        pinned: 'right',
        minWidth: 120,
        cellRenderer: params => {
          return `  <i class="fas fa-fw fa-bars" id="moreDetail" style="margin-right:3px; cursor: pointer;"></i>
          ${params?.data?.reviewStatus !== ReviewStatus.PrepareForSubmission && params?.data?.status !== 'TakeDown' ? `<i class="fas fa-fw fa-edit text-primary" id="editDetail" style="margin-right:3px; cursor: pointer;"></i>` : ``} `
        },
        onCellClicked: params => {
          switch (params.event.target.id) {
            case 'moreDetail':
              this.modalService.showDetail(params?.data, 'Asset Detail')
              break;
            case 'editDetail':
              this.update(params?.data)
              break;
          }
        },
      },
    ];
  }


  update(data) {
    this.nzModalService.create({
      nzContent: UpdateVersionComponent,
      nzTitle: 'Update Product Version State',
      nzFooter: null,
      nzOnOk: () => this.fetchAll(),
      nzComponentParams: {
        id: data?.id,
        currentReviewStatus: data?.reviewStatus,
        type: this.currentFocusOn
      }
    })
  }


  fetchAll() {
    const buildParams = (prop) => {
      if (this.initialProduct) {
        if (this.currentFocusOn === 'Product') {
          return { ...prop, ProductId: this.initialProduct }
        } else {
          return { ...prop, ModelId: this.initialProduct }
        }
      } else {
        return prop
      }
    };
    switch (this.currentFocusOn) {
      case 'Product':
        this.setDatasource((prop) => this.partnerService.getProductsVersion(buildParams(prop)));
        break;
      case '3DModel':
        this.setDatasource((prop) => this.partnerService.getModelsVersion(buildParams(prop)));
        break;
    }
  }

  changeTab(tab) {
    this.currentFocusOn = tab
    this.setColumnDefs();
    this.fetchAll()
  }
}
